import { API_COMPOSER_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { Error } from '@eggplant/types'

interface Props {
  id: string
  onSuccess?: () => void
  onError?: (error: Error) => void
  children?: () => React.ReactNode
}

const DeleteComposerWebhooksRequest = ({
  id,
  onSuccess,
  onError,
  children
}: Props) => {
  const url = `${API_COMPOSER_SERVICE}/webhooks/${id}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='delete'
      onError={onError}
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default DeleteComposerWebhooksRequest
